import { AfterViewInit, Component, OnInit } from '@angular/core'
import { AcmSupaDemoDialogService } from '../acm-supa-demo-dialog/acm-supa-demo-dialog.service'
import { AcmSupaDemoService } from '../acm-supa-demo.service'
import { Store } from '@ngrx/store'
import { AuthService } from '@tv3/services/auth.service'
import { Destroyable, selectSomeOnce, selectUserById, untilDestroy, User } from '@tokeet/tv3-platform'
import { BehaviorSubject, combineLatest } from 'rxjs'
import { filter, switchMap } from 'rxjs/operators'

@Component({
  selector: 'app-acm-supa-demo-starter',
  template: '',
})
export class AcmSupaDemoStarterComponent extends Destroyable implements OnInit, AfterViewInit {
  isInitialized$ = new BehaviorSubject<boolean>(false)
  constructor(
    private demoDialog: AcmSupaDemoDialogService,
    private demoService: AcmSupaDemoService,
    private store: Store<any>,
    private auth: AuthService
  ) {
    super()
  }

  ngOnInit(): void {
    combineLatest([this.isInitialized$.pipe(filter((s) => s)), this.demoService.pageNavigationEnd$])
      .pipe(
        filter(() => this.auth.isAuthenticated),
        switchMap(() => this.store.pipe(selectSomeOnce(selectUserById(this.auth.user.id)))),
        untilDestroy(this)
      )
      .subscribe((user) => {
        this.tryToShowDemo(user)
      })
  }

  ngAfterViewInit(): void {
    this.isInitialized$.next(true)
  }

  tryToShowDemo(user: User) {
    let demo = this.demoService.getDemoForCurrentPage()
    if (!demo || this.demoService.isDemoViewed(user, demo)) return

    this.demoDialog
      .open(demo)
      .afterOpened()
      .subscribe(() => {
        this.demoService.viewDemo(user, demo)
      })
  }
}
